module.exports = __webpack_public_path__ + "img/folder-green.8b9ac1c7.svg";